import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AdminGuard, AdminTitle, EmailList } from "@/components/admin/AdminGuard";
import { OrderStatus } from "@/components/OrderSummary";
import { errText } from "@/lib/api";
import { adminDashboard } from "@/lib/admin";
import { cad } from "@/lib/site";

const Stat = ({ label, value, bg = "bg-cloud", testid, to }) => {
  const body = (
    <div className={`h-full border-[1.5px] border-ink p-5 ${bg}`} data-testid={testid}>
      <p className="label font-bold">{label}</p>
      <p className="display mt-4 text-5xl">{value}</p>
    </div>
  );
  return to ? <Link to={to} className="block transition-transform hover:-translate-y-0.5">{body}</Link> : body;
};

const Panel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { adminDashboard().then(setD).catch((e) => toast.error(errText(e))); }, []);
  if (!d) return <p className="label pt-10 text-ink/60">Loading…</p>;
  return (
    <>
      <AdminTitle>Dashboard</AdminTitle>
      <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Revenue (CAD)" value={cad(d.revenue)} bg="bg-lime" testid="dash-revenue" />
        <Stat label="Paid orders" value={d.paid_orders} bg="bg-pink" testid="dash-paid-orders" to="/admin/orders" />
        <Stat label="To fulfil" value={d.to_fulfil} bg="bg-sky" testid="dash-to-fulfil" to="/admin/orders" />
        <Stat label="Units sold" value={d.units_sold} testid="dash-units" />
        <Stat label="Products" value={d.products} testid="dash-products" to="/admin/products" />
        <Stat label="Low stock (≤5)" value={d.low_stock} testid="dash-low-stock" to="/admin/products" />
        <Stat label="Subscribers" value={d.subscribers} testid="dash-subscribers" to="/admin/subscribers" />
        <Stat label="SOTM pending" value={d.sotm_pending} testid="dash-sotm-pending" to="/admin/sus-of-the-month" />
      </div>
      <div className="mt-14 grid gap-12 xl:grid-cols-2">
        <section>
          <h2 className="label font-bold">Recent paid orders</h2>
          <ul className="mt-4" data-testid="dash-recent-orders">
            {!d.recent_orders.length && <li className="text-sm text-ink/60">No paid orders yet.</li>}
            {d.recent_orders.map((o) => (
              <li key={o.id} className="flex items-center justify-between gap-4 border-b border-ink/10 py-3 text-sm">
                <Link to={`/admin/orders?id=${o.id}`} className="font-mono underline-offset-4 hover:underline">{o.order_number}</Link>
                <span className="flex-1 truncate text-ink/70">{o.name}</span><OrderStatus status={o.status} /><span>{cad(o.total)}</span>
              </li>
            ))}
          </ul>
        </section>
        <section>
          <h2 className="label font-bold">Emails <span className="text-ink/60">· {d.emails.sent} sent · {d.emails.failed} failed</span></h2>
          <div className="mt-4"><EmailList emails={d.recent_emails} testid="dash-recent-emails" /></div>
        </section>
      </div>
    </>
  );
};

export default function AdminDashboard() {
  return <AdminGuard><Panel /></AdminGuard>;
}
